import React from 'react';

class NotFound extends React.Component {
  render() {
    return (
      <div className="NotFound">
        <h1>Cannot find anything in this URL</h1>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound.js